import ComponentInitializer from '../libs/component-initializer';
import Cart from '../libs/cart';
import { EVENT_GLOBAL_UPDATE_CART } from '../constants/event';
import ComponentBase from './base/component-base';

class CartCounterComponent extends ComponentBase {
  protected cartCountBinding: ((e: CustomEvent) => void) | null = null;

  constructor(element: HTMLElement) {
    super(element);
    this.init();
  }

  protected init() {
    super.init();
    this.cartCountBinding = this.onCartCount.bind(this);
    // if (this.cartCountBinding) {
    //   document.addEventListener(EVENT_GLOBAL_UPDATE_CART, this.cartCountBinding);
    // }
  }

  protected onCartCount(e: CustomEvent) {
    this.updateCount();
  }

  protected updateCount() {
    this.element.textContent = Cart.count.toString();
  }

  protected destroyEventListeners() {
    super.destroyEventListeners();
    if (this.cartCountBinding) {
      document.removeEventListener(
        EVENT_GLOBAL_UPDATE_CART,
        this.cartCountBinding
      );
    }
  }
}

ComponentInitializer.initializeComponent(
  '.j-cart-counter',
  CartCounterComponent
);
